import { useEffect, useState } from "react";
import { Modal, Table, Spinner, Badge } from "react-bootstrap";
import axiosInstance from "../../../axiosInstance";
import { formatVND as fmtVND } from "../utils/moneyFormat";
import "../accountingResponsive.css";

const unwrap = (res) => res?.data?.data ?? res?.data ?? {};

const DEBT_STATUS_MAP = {
  OPEN: { label: "Còn nợ", bg: "warning" },
  PARTIAL: { label: "Thanh toán một phần", bg: "info" },
  CLOSED: { label: "Đã thanh toán đủ", bg: "success" },
  OVERDUE: { label: "Quá hạn", bg: "danger" },
};

const DebtDetailModal = ({ show, onHide, type, entityId, entityCode }) => {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({ debts: [] });

  const isReceivable = type === "receivable";
  const title = isReceivable ? "Chi tiết công nợ phải thu" : "Chi tiết công nợ phải trả";
  const codeLabel = isReceivable ? "Đối tượng thu" : "Mã đối tượng chi";
  const voucherCodeLabel = isReceivable ? "Mã phiếu thu" : "Mã phiếu chi";

  useEffect(() => {
    if (!show || !entityId) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const endpoint = isReceivable
          ? `/api/accounting/receivables/${entityId}/detail`
          : `/api/accounting/payables/${entityId}/detail`;
        const res = await axiosInstance.get(endpoint);
        if (!cancelled) setDetail(unwrap(res) || { debts: [] });
      } catch (_) {
        if (!cancelled) setDetail({ debts: [] });
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [show, entityId, isReceivable]);

  return (
    <Modal show={show} onHide={onHide} size="xl" centered scrollable fullscreen="sm-down">
      <Modal.Header closeButton>
        <Modal.Title>{title} — {codeLabel}: {entityCode || entityId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div>
        ) : (detail.debts || []).length === 0 ? (
          <div className="text-muted text-center py-3">Không có khoản công nợ</div>
        ) : (
          <div className="acc-table-wrap">
            <Table striped hover size="sm" className="mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Ngày phát sinh</th>
                  <th className="text-end">Tổng nợ</th>
                  <th className="text-end">Đã thanh toán</th>
                  <th className="text-end">Còn lại</th>
                  <th className="text-center">Tuổi nợ</th>
                  <th className="text-center">Trạng thái</th>
                  <th>Ngày thanh toán</th>
                  <th>{voucherCodeLabel}</th>
                </tr>
              </thead>
              <tbody>
                {(detail.debts || []).map((d) => (
                  <tr key={d.id}>
                    <td>#{d.id}</td>
                    <td>{d.createdAt || "—"}</td>
                    <td className="text-end">{fmtVND(d.totalAmount)}</td>
                    <td className="text-end">{fmtVND(d.paidAmount)}</td>
                    <td className="text-end fw-semibold">{fmtVND(d.remainingAmount)}</td>
                    <td className="text-center">{d.agingDays || 0} ngày</td>
                    <td className="text-center">
                      <Badge bg={DEBT_STATUS_MAP[d.status]?.bg || "secondary"}>
                        {DEBT_STATUS_MAP[d.status]?.label || d.status}
                      </Badge>
                    </td>
                    <td>{d.paymentDate || ""}</td>
                    <td>{d.voucherCode || ""}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DebtDetailModal;
